"use client";

import { useEffect } from "react";

declare global {
  interface Window {
    EMRPixel?: {
      init: (domain: string, id: number) => void;
    };
  }
}

export const HeadSpaReviewsWidget = () => {
  useEffect(() => {
    // Vérifier si le script est déjà chargé
    if (window.EMRPixel) {
      console.info("EMR: Pixel already loaded");
      return;
    }

    // Créer et charger le script
    const script = document.createElement("script");
    script.defer = true;
    script.src = `https://cdn2.revw.me/js/pixel.js?t=${
      864e5 * Math.ceil(new Date().getTime() / 864e5)
    }`;
    script.charset = "utf-8";

    script.onload = () => {
      if (window.EMRPixel) {
        window.EMRPixel.init("app.getcoucou.io", 20);
      }
    };

    // Insérer le script dans le document
    const firstScript = document.getElementsByTagName("script")[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    }

    // Cleanup au démontage du composant
    return () => {
      // Le script reste chargé pour éviter les rechargements multiples
    };
  }, []);

  return (
    <section className="w-full bg-tertiary py-20">
      <div className="mx-auto flex max-w-[1920px] flex-col gap-8 px-4 ph:px-24 md:px-48 lg:px-72 xl:px-96">
        <h2 className="font-cormorant text-4xl ph:text-5xl sm:text-6xl lg:text-7xl">
          AVIS
        </h2>
        <emr-simple-carousel widget-id="dbe08008-66c3-4cf2-99cc-6b2072bfd3ad"></emr-simple-carousel>
      </div>
    </section>
  );
};
